<template>
    <a href="/favorites" title="Перейти в избранное" class="header-bottom__user-item header-bottom__favorites">
        <span class="header-bottom__user-item-icon">
            <FavoritesIcon/>
            <span class="header-bottom__user-item-badge text text__twelve" v-if="count > 0">
                {{ count }}
            </span>
        </span>
        <span class="header-bottom__user-item-text text text__twelve">
            Избранное
        </span>
    </a>
</template>

<script>
    import FavoritesIcon from "../icons/FavoritesIcon";
    import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
    export default {
        name: "TheFavoritesWidget",
        components: {
            FavoritesIcon
        },
        methods: {
            ...mapActions({
                'loadCheckout': 'favorites/loadCheckout'
            })
        },
        computed: {
            ...mapGetters('favorites', {
                'count': 'count'
            })
        },
        mounted() {
            this.loadCheckout();
        }
    }
</script>

<style lang="scss">

</style>